// The boat's left sidebar opens with its labels and can be closed to its icons
// (Mike, 2026-10-16). The choice belongs to this browser: a convenience kept
// in its storage, and a storage that is unavailable or throws keeps the labels.

const KEY = 'tombolo.sidebar.compact';

/** True when the owner closed the sidebar to its icons in this browser. */
export function readSidebarCompact(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function writeSidebarCompact(compact: boolean): void {
  try {
    if (compact) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Not kept: it holds until the page reloads.
  }
}
